export const getSeatInformationLabel = (companyIataCode: string) => {
  switch (companyIataCode) {
    case 'AF': {
      return 'Option Payante Siège'
    }
    case 'BF': {
      return 'Option Payante Siège (tarifs par personne et par trajet)'
    }
    case 'SS': {
      return 'Option Payante Siège (tarifs par personne et par trajet)'
    }
    case 'UU': {
      return 'Siège (tarif par personne et par trajet)'
    }
  }
}

export const getSeatInformationText = (companyIataCode: string) => {
  switch (companyIataCode) {
    case 'AF': {
      return "La politique tarifaire des sièges sur Air France dépend entre autre du type avion, de l'emplacement dans la cabine, etc, les sièges standard commencent à partir de 30 €uros, au besoin contacter l'agence si vous désirez un type de siège ou un emplacement.\n\n Les sièges en issues de secours sont des options à 85 €. *Les passagers doivent être valides et avoir moins de 65 ans."
    }
    case 'BF': {
      return 'Pour les sièges en issues de secours : Les passagers doivent être valides et avoir moins de 65 ans.'
    }
    case 'SS': {
      return "Pour des demandes spéciales d'attribution de sièges (obésité, passagers à mobilité réduite, etc) contacter directement l'agence.\n\n *Les sièges en issues de secours : Les passagers doivent être valides et avoir moins de 65 ans."
    }
    case 'UU': {
      return "*Issue de Secours : le passager doit être valide et avoir moins de 65 ans. \n\n Pour des demandes spéciales d'attribution de sièges (obésité, passagers à mobilité réduite, etc, contacter directement l'agence."
    }
    default: {
      return "Si vous désirez des options de type sièges, repas, bagages... merci de contacter directement l'agence au 0491910698 aux heures de bureau."
    }
  }
}

export interface SeatOption {
  label: string
}

export const getSeatInformationOptions = (companyIataCode: string): SeatOption[] => {
  switch (companyIataCode) {
    case 'AF': {
      return [
        { label: 'NON' },
        { label: 'Côté couloir' },
        { label: 'Côté hublot' },
        { label: 'Issue de secours*' },
      ]
    }
    case 'BF': {
      return [
        { label: 'NON' },
        { label: 'Compartiment 1 Coté hublot : 35€' },
        { label: 'Compartiment 1 Couloir : 35€' },
        { label: 'Compartiment 1 Issue de secours* : 55 €' },
        { label: 'Compartiment suivant Coté hublot : 25 €' },
        { label: 'Compartiment suivant Couloir : 20 €' },
        { label: 'Compartiment suivant Issue de secours* : 35 €' },
      ]
    }
    case 'SS': {
      return [
        { label: 'NON' },
        { label: 'Côté couloir - 25 €' },
        { label: 'Côté hublot - 25 €' },
        { label: "Sièges biplaces (fond de l'appareil) - 45 €" },
        { label: 'Sièges coté Hublot sortie rapide - 85 €' },
        { label: 'Sièges coté Couloir sortie rapide - 85 €' },
        { label: 'Issues de secours - 75 à 85 €*' },
      ]
    }
    case 'UU': {
      return [
        { label: 'NON' },
        { label: 'Standard Côté couloir - 30 €' },
        { label: 'Standard Côté hublot - 30 €' },
        { label: "Sortie rapide hublot (avant de l'appareil) - 45 €" },
        { label: "Sortie rapide couloir (avant de l'appareil) - 45 €" },
        { label: "Siège DUO au fond de l'appareil - 45 €" },
        { label: 'Issue de secours* - 90 €' },
      ]
    }
    default: {
      return []
    }
  }
}
